export default __webpack_public_path__ + "static/Mallory-Book-7dac22a17daa12b3e2a13650c98a22ae.woff";